import React, { FC, useRef } from 'react'
import { Box, Track, useSlider, Icon, SliderIndicators } from '@gassan-ui'
import { ContentSlide } from '@lib/kontent/models/ContentSlide'
import * as S from './elements'
import Slide from './Slide'

type Props = {
  items: ContentSlide[]
}

const InfoBlockSlider: FC<Props> = ({ items }) => {
  const trackRef = useRef<HTMLElement>(null)
  const { onTouchEnd, prev, next, canMoveRight, canMoveLeft, index } = useSlider({ trackRef })

  return (
    <Box bg="shades.50" position="relative" pb={{ _: '0', large: '5rem', xlarge: '7.5rem' }}>
      <Box
        maxWidth="90rem"
        m="0 auto"
        width={{
          _: '100%',
          small: 'calc(100% - 4rem)',
          large: 'calc(100% - 5.5rem)'
        }}
        position="relative"
      >
        <Track ref={trackRef} onTouchEnd={onTouchEnd}>
          {items.map((item, key) => (
            <Slide key={key} isActive={key === index} {...item} />
            // <Slide
            //   key={key}
            //   index={key}
            //   title={item.title.value}
            //   text={item.text.value}
            //   image={item.image.value[0]?.url}
            //   mobileImage={item.mobile_image.value[0]?.url}
            //   alt={item.image.value[0]?.description}
            //   linkText={item.link_text.value}
            //   linkHref={item.link_url.value}
            //   imageIsLogo={!!item.image_is_logo.value[0]}
            //   isActive={key === index}
            //   richText={}
            // />
          ))}
        </Track>

        {items.length > 1 && (
          <>
            <Box
              width="100%"
              display={{ _: 'flex', large: 'none' }}
              justifyContent="center"
              pb={['2rem', '3rem']}
            >
              <SliderIndicators active={index} total={items.length} />
            </Box>
            <S.NavButton onClick={prev} isLeft disabled={!canMoveLeft}>
              <Icon icon="chevron-left" />
            </S.NavButton>
            <S.NavButton onClick={next} disabled={!canMoveRight}>
              <Icon icon="chevron-right" />
            </S.NavButton>
          </>
        )}
      </Box>
    </Box>
  )
}

export default InfoBlockSlider
